<div class="dropdown ihost-dropdown ihost-replace-val mb-2">
    <a class="dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
        <span *ngIf="selectedColor == null">{{ 'common.info.selectColor' | translate }}</span>

        <span *ngIf="selectedColor != null">
            <span class="color-square color-square-sm" [ngStyle]="{ 'background-color': selectedColor.value }"></span>
            {{selectedColor.display}}
        </span>
    </a>
    <div class="dropdown-menu dropdown-colors">
        <a (click)="colorSelected(color)" class="dropdown-color" *ngFor="let color of colors">
            <span class="color-square color-square-sm" [ngStyle]="{ 'background-color': color.value }"></span>
        </a>
    </div>
</div>